import { render, staticRenderFns } from "./ProductSelectionBase.vue?vue&type=template&id=34f77591&scoped=true&lang=html&"
import script from "./ProductSelectionBase.vue?vue&type=script&lang=js&"
export * from "./ProductSelectionBase.vue?vue&type=script&lang=js&"
import style0 from "./ProductSelectionBase.vue?vue&type=style&index=0&id=34f77591&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f77591",
  null
  
)

export default component.exports